import { render, staticRenderFns } from "./AppDownloadBar.vue?vue&type=template&id=639543be&"
import script from "./AppDownloadBar.vue?vue&type=script&lang=js&"
export * from "./AppDownloadBar.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports